import { LstBalance } from "../../rest/kairos/types";

export interface StakeTokenOption {
  symbol: string;
  name: string;
  imageUri: string;
  mint: string;
  balance: number;
  /** USD value from API when available */
  value: number | null;
}

export function buildRestakeTokenOptions(
  solBalance: number,
  jitoSolMint: string,
  jitoSolBalance: number,
  lstBalances: LstBalance[] | null
): StakeTokenOption[] {
  const options: StakeTokenOption[] = [
    {
      symbol: "SOL",
      name: "Solana",
      imageUri: "/solana.png",
      mint: "native",
      balance: solBalance,
      value: null,
    },
    {
      symbol: "JitoSOL",
      name: "Jito Staked SOL",
      imageUri: "/jitosol.png",
      mint: jitoSolMint,
      balance: jitoSolBalance,
      value: null,
    },
  ];

  const seenMints = new Set([jitoSolMint, "native"]);

  lstBalances?.forEach((lst) => {
    const mint = lst.metadata?.mint;
    const symbol = lst.metadata?.symbol;
    if (!mint || !symbol || seenMints.has(mint)) return;
    if (symbol.toLowerCase() === "jitosol") return;

    seenMints.add(mint);
    options.push({
      symbol,
      name: lst.metadata?.name ?? symbol,
      imageUri: lst.metadata?.imageUri ?? "/unknown.svg",
      mint,
      balance: lst.balance,
      value: lst.value ?? null,
    });
  });

  return options;
}
